// import moment from 'moment'

/**
 * 获取1小时降雨
 */
export function getIcyRoadOption (timAarr, temp, luTemps, hourrf, riskArr, splitArr) {
  return {
    color: ['rgba(45, 116, 245, 1)', 'rgba(246, 171, 0, 1)', 'rgba(29, 207, 193, 1)', 'rgba(211, 32, 6, 1)'],
    grid: {
      // left: 50,
      // right: 30,
      top: 40,
      bottom: 30
    },
    legend: {
      show: true,
      left: '40px',
      itemGap: 30

    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      axisTick: {
        show: false
      },
      axisLine: {
        onZero: false
      },
      data: timAarr
    },
    yAxis: [
      {
        type: 'value',
        name: '温度（℃）',
        splitLine: {
          show: false
        },
        nameLocation: 'middle',
        nameGap: 50,
        max: Math.max(...temp, ...luTemps) + 3,
        min: Math.min(...temp, ...luTemps) - 3,
        nameTextStyle: {
          fontSize: '14px',
          color: '#666666'
        },
        axisLabel: {
          formatter: function (value) {
            return value.toFixed(1)
          }
        }
      },
      {
        type: 'value',
        name: '降水（mm）',
        splitLine: {
          show: false
        },
        max: Math.max(...hourrf),
        min: Math.min(...hourrf),
        nameLocation: 'middle',
        nameGap: 50,
        nameTextStyle: {
          fontSize: '14px',
          color: '#666666'
        }
      }
    ],
    series: [
      {
        name: '气温',
        data: temp,
        type: 'line',
        smooth: true
      },
      {
        name: '路温',
        data: luTemps,
        type: 'line',
        smooth: true
      },
      {
        name: '降水',
        data: hourrf,
        type: 'bar',
        yAxisIndex: 1,
        barMaxWidth: 30,
        barMinWidth: 5
      },
      {
        name: '风险时段',
        data: riskArr,
        type: 'line',
        smooth: true,
        // markArea: {
        //   itemStyle: {
        //     color: 'rgba(211, 32, 6, 0.1)'
        //   },
        //   data: splitArr
        //   // data: a
        // },
        areaStyle: {
          color: 'rgba(211, 32, 6, 0.2)',
          origin: 'start'
        }
      }
    ]
  }
}
